import { ImagePreviewer } from "../ImagePreview/ImagePreviewer";
import * as A from "../ui/avatar";

type TProps = {
  src?: string;
  name: string;
  bg?: "none" | string;
  size?: string | number;
  className?: string;
  showHoverContent?: boolean;
};

const Avatar: React.FC<TProps> = ({
  bg,
  name,
  src,
  size,
  className,
  showHoverContent,
}) => {
  return (
    <ImagePreviewer
      imagesSrc={src ?? ""}
      showHoverContent={showHoverContent}
      alt={`${name || "User"}'s Avatar`}
      trigger={
        <>
          <A.SAvatar
            bg={bg}
            name={name}
            src={src}
            size={size}
            className={className}
          />
        </>
      }
    />
  );
};

export default Avatar;
